export default __webpack_public_path__ + "static/media/graphics-design.08c25c6b.png";